import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { toast } from 'react-toastify';
import { parseError } from '../shared/error';
import { externalLayersKeys } from './queryKeys';
import { layerNodesKeys } from 'hooks/layerNode/queryKeys';

export function useDeleteExternalLayerMutation() {
  const queryClient = useQueryClient();

  return useMutation<void, unknown, { externalLayerId: UUID }>({
    mutationFn: async ({ externalLayerId }) => {
      await axios.delete(
        `${config.apiGateway.external_layers}/${externalLayerId}`
      );
    },
    onSuccess: () => {
      toast.success('External layer deleted');
      queryClient.invalidateQueries({ queryKey: externalLayersKeys.all() });
      queryClient.invalidateQueries({ queryKey: layerNodesKeys.all() });
    },
    onError: (error) => {
      toast.error(parseError(error));
    },
  });
}
